import React from "react";
import BillingPage from "../../components/admin/BillingPage";
export default function Quotations() { return <BillingPage kind="quotation" />; }
